module.exports = __webpack_public_path__ + "img/logo_small.7525c57b.jpeg";